<div>
    <p-toast></p-toast>
    <form [formGroup]="searchForm">
        <div>
            <div class="row mb-2">
                <div class="col-md-9">
                    <input type="text" pInputText formControlName="searchQuery" (keydown.enter)="searchName()" class="form-control" />
                </div>
                <div class="col-md-3">
                    <button type="button" pButton pRipple icon="pi pi-search" class="btn btn-danger w-100 p-button-danger" (click)="searchName()" [label]="'search.button' | translate"></button>
                </div>
            </div>
            
            <div class="card" *ngIf="process=='CUSTOMER'">
                <p-table [value]="customerModel" selectionMode="single" dataKey="code"
                         responsiveLayout="scroll" class="overflow-auto" [scrollHeight]="'250px'">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'search.table.id' | translate}}</th>
                            <th>{{'search.table.name' | translate}}</th>
                            <th>{{'search.table.salesforceId' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-cus>
                        <tr (click)="selectCustomer(cus)">
                            <td>{{ cus.id }}</td>
                            <td>{{ cus.name }}</td>
                            <td>{{ cus.salesforceId }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="card" *ngIf="process=='RESP'">
                <p-table [value]="responsibleModel" selectionMode="single" dataKey="code"
                         responsiveLayout="scroll" class="overflow-auto" [scrollHeight]="'250px'">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'search.table.user' | translate}}</th>
                            <th>{{'search.table.name' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-resp>
                        <tr (click)="selectResp(resp)">
                            <td>{{ resp.user }}</td>
                            <td>{{ resp.name }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="card" *ngIf="process=='TEAM'">
                <p-table [value]="teamsModel" selectionMode="single" dataKey="code"
                         responsiveLayout="scroll" class="overflow-auto" [scrollHeight]="'250px'">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'search.table.id' | translate}}</th>
                            <th>{{'search.table.description' | translate}}</th>
                            <th>{{'search.table.country' | translate}}</th>
                            <th>{{'search.table.active' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-team>
                        <tr (click)="selectItem(team)">
                            <td>{{ team.id }}</td>
                            <td>{{ team.description }}</td>
                            <td>{{ team.country }}</td>
                            <td>{{ team.status == 1 ? ('search.table.active' | translate) : ('search.table.inactive' | translate) }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </form>
</div>